module.exports = __webpack_public_path__ + "img/title-4.3a5ce197.png";